// extracted by mini-css-extract-plugin
var _1 = "TableCell-module__animateUploadProgressBarWidth--eqM7v";
var _2 = "TableCell-module__animatedBackground--m0As2";
var _3 = "TableCell-module__bottomBorder--OhEKn";
var _4 = "TableCell-module__container--Ukyvs";
var _5 = "TableCell-module__deltaPreviewContainer--XK_5F";
var _6 = "TableCell-module__editorContainer--Ckwaa";
var _7 = "TableCell-module__firstColumn--cvXfO";
var _8 = "TableCell-module__firstRow--AKSmL";
var _9 = "TableCell-module__hideControls--fnZ45";
var _a = "TableCell-module__inLastTruncatedRow--uiCpf";
var _b = "TableCell-module__inRange--vqEjT";
var _c = "TableCell-module__leftBorder--Gg_tu";
var _d = "TableCell-module__rightBorder--BgpU0";
var _e = "TableCell-module__topBorder--hK8wi";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "bottomBorder", _4 as "container", _5 as "deltaPreviewContainer", _6 as "editorContainer", _7 as "firstColumn", _8 as "firstRow", _9 as "hideControls", _a as "inLastTruncatedRow", _b as "inRange", _c as "leftBorder", _d as "rightBorder", _e as "topBorder" }
